export default {
  name: 'custom-tracking',

  componentDidMount () {
    if (this.el.dataset.type === 'jobs') {
      this.el.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', (e) => {
          gtag('event', 'offre-emploi', { button_text: `${e.target.textContent}` })
        })
      })
    }
  },
}
